var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('p',{staticClass:"lead"},[_vm._v("Cargando...")]),_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }